<template>
  <div>
    <div class="banner innerpageBanner">
      <div class="container">
        <div class="caption">
          <div>
            <h1>Tasting Reports</h1>
            <p>Reports from inside and outside Burgundy</p>
          </div>
        </div>
      </div>

      <img
        src="https://www.insideburgundy.com/wp-content/uploads/2018/09/banner-9-1.jpg"
        alt
        class="cover-image"
      >
    </div>
    <section class="innerPage">
      <div class="container">
        <div class="breadcrumbWrap">
          <div class="breadcrumb">
            <!-- Breadcrumb NavXT 6.2.0 -->
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="index.html#/insideburgundy"
                class="home"
              >
                <span property="name">Home</span>
              </a>
              <meta property="position" content="1">
            </span> /
            <span property="itemListElement" typeof="ListItem">
              <span property="name">Tasting Reports</span>
              <meta property="position" content="2">
            </span>
            <div data-object_id="19" class="cbxwpbkmarkwrap cbxwpbkmarkwrap-page">
              <a
                data-loggedin="0"
                data-type="page"
                data-object_id="19"
                class="cbxwpbkmarktrig cbxwpbkmarktrig-button-addto"
                title="Bookmark This"
                href="#"
              >
                <span class="cbxwpbkmarktrig-label">Bookmark</span>
              </a>
              <div
                data-type="page"
                data-object_id="19"
                class="cbxwpbkmarkguestwrap"
                id="cbxwpbkmarkguestwrap-19"
              >
                <div class="cbxwpbkmarkguest-message">
                  <a href="#" class="cbxwpbkmarkguesttrig_close"></a>
                  <a
                    class="cbxwpbkmarkguest-text"
                    href="index.html#/Login"
                  >Please login to bookmark</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Search -->
       <searchBox  />
      </div>

      <div class="container">
        <div class="rightCol">
          <div class="tastingNav">
            <h4>
              Reports By:
              <span></span>
            </h4>
            <ul class="mainParent">
              <li>
                <a class>Vintage</a>
                <ul class="firstLevel" style="display:none;">
                  <li>
                    <a class="trigger">2017</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/2017-the-vintage-report-chablis/"
                        >2017: The Vintage Report (Chablis)</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/2017-the-vintage-report-cote-de-beaune/"
                        >2017: The Vintage Report (Côte de Beaune)</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/2017-the-vintage-report-cote-de-nuits/"
                        >2017: The Vintage Report (Côte de Nuits)</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/2017-the-vintage-report-introduction/"
                        >2017: The Vintage Report (Introduction)</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/2017s-in-london/"
                        >2017s in London</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/maconnais-2017/"
                        >Mâconnais 2017</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">2016</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/2016-the-vintage-report-chablis/"
                        >2016: The Vintage Report (Chablis)</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/2016-vintage-in-the-cote-dor/"
                        >2016: The Vintage Report (Côte d'Or)</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">2015</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/red-burgfest-2015/"
                        >Red Burgfest 2015</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/white-burgfest-2015/"
                        >White Burgfest 2015</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">2014</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/2014-white-burgundy/"
                        >White Burgfest: The 2014 vintage</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/red-burgfest-2014/"
                        >Red Burgfest: The 2014 vintage</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">2008</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/ten-year-on-tasting-2008-vintage/"
                        >2008: Ten Years On</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">2007</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/ten-year-on-tasting-2007-vintage/"
                        >Ten year on tasting: 2007 vintage</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">2002</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/2002-revisited/"
                        >2002 Revisited</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">1998</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/20-year-on-tasting-1998-vintage/"
                        >1998: Twenty Years On</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">1997</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/1997-twenty-years-on/"
                        >1997: Twenty Years On</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <a class>Producer</a>
                <ul class="firstLevel" style="display:none;">
                  <li>
                    <a class="trigger">Bachelet, Domaine Denis</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/domaine-denis-bachelet-charmes-chambertin-vieilles-vignes/"
                        >Domaine Denis Bachelet: Charmes Chambertin Vieilles Vignes</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Cathiard, André</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/domaine-cathiard-retrospective/"
                        >Domaine Cathiard Retrospective</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Cathiard, Domaine Sylvain</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/sylvain-cathiard-dinner/"
                        >Domaine Cathiard Dinner</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Coche-Dury, Domaine</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/the-wizards-of-meursault-1-coche-dury/"
                        >The Wizards of Meursault 1: Coche-Dury</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Drouhin, Joseph</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/le-musigny-joseph-drouhin-2009-to-1978/"
                        >Joseph Drouhin: Le Musigny</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Dugat-Py, Domaine</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/domaine-dugat-py-dinner/"
                        >Domaine Dugat-Py dinner</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Dujac, Domaine</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/dujac-double-double-bill-part-2-part-2-dujac-at-la-tour-dargent/"
                        >Domaine Dujac - a Double Double Bill (2)</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/dujac-double-double-bill-part1-clos-de-la-roche-and-clos-st-denis/"
                        >Domaine Dujac - a Double Double Bill (1)</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Engel, Domaine René</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/domaine-rene-engel-vertical/"
                        >Domaine René Engel Retrospective</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Ente, Domaine Arnaud</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/the-wizards-of-meursault-2-domaine-arnaud-ente/"
                        >The wizards of Meursault 2: Domaine Arnaud Ente</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Grivot, Domaine Jean</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/richebourg-domaine-jean-grivot-vertical/"
                        >Domaine Jean Grivot: Richebourg</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Gros, Domaine Anne</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/richebourg-retrospective-domaines-anne-francois-jean-gros/"
                        >Richebourg Retrospective: Domaines Anne, François &amp; Jean Gros</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Jadot, Domaine Héritiers Louis</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/louis-jadot-chevalier-montrachet-les-demoiselles/"
                        >Louis Jadot: Chevalier-Montrachet Les Demoiselles</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/louis-jadot-musigny/"
                        >Louis Jadot: Musigny</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Lafon, Domaine des Comtes</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/mature-volnay/"
                        >Mature Volnay</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/volnay-santenots-du-milieu-domaine-des-comtes-lafon/"
                        >Domaine des Comtes Lafon: Volnay Santenots-du-Milieu</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Lamarche, Domaine François</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/la-grande-rue/"
                        >Domaine Lamarche: La Grande Rue</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Leroy, Domaine</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/clos-de-vougeot-grand-cru-domaine-leroy/"
                        >Domaine Leroy: Clos de Vougeot</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/domaine-rene-engel-dinner/"
                        >Domaine René Engel Dinner</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Mortet, Domaine Denis</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/chambertin-denis-mortet/"
                        >Domaine Denis Mortet: Chambertin</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Méo-Camuzet, Domaine</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/richebourg-domaine-meo-camuzet/"
                        >Domaine Méo-Camuzet: Richebourg</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Roumier, Domaine G</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/chambolle-musigny-1er-cru-les-amoureuses-domaine-g-roumier/"
                        >Domaine G Roumier: Chambolle-Musigny Les Amoureuses</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/domaine-g-roumier-bonnes-mares/"
                        >Domaine G Roumier: Bonnes Mares</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Roumier, Domaine Georges</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/christophe-roumier-ruchottes-chambertin/"
                        >Christophe Roumier: Ruchottes-Chambertin</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Rousseau, Domaine Armand</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/chambertin-clos-de-beze-grand-cru-domaine-armand-rousseau/"
                        >Domaine Armand Rousseau: Chambertin Clos de Bèze</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/domaine-rousseau-chambertin-vertical/"
                        >Domaine Armand Rousseau: Chambertin</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Tart, Domaine du Clos de</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/clos-de-tart-sylvain-pitiot-retrospective/"
                        >Clos de Tart: Sylvain Pitiot Retrospective</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Vougeraie, Domaine de la</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/clos-blanc-de-vougeot-vertical-2008-1999/"
                        >Domaine de la Vougeraie: Clos Blanc de Vougeot</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <a class>Village</a>
                <ul class="firstLevel" style="display:none;">
                  <li>
                    <a class="trigger">Chablis</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/2016-the-vintage-report-chablis/"
                        >2016: The Vintage Report (Chablis)</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Chambolle-Musigny</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/chambolle-musigny-1er-cru-les-amoureuses-domaine-g-roumier/"
                        >Domaine G Roumier: Chambolle-Musigny Les Amoureuses</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/le-musigny-joseph-drouhin-2009-to-1978/"
                        >Joseph Drouhin: Le Musigny</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/louis-jadot-musigny/"
                        >Louis Jadot: Musigny</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Gevrey-Chambertin</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/chambertin-clos-de-beze-grand-cru-domaine-armand-rousseau/"
                        >Domaine Armand Rousseau: Chambertin Clos de Bèze</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/chambertin-denis-mortet/"
                        >Domaine Denis Mortet: Chambertin</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/domaine-rousseau-chambertin-vertical/"
                        >Domaine Armand Rousseau: Chambertin</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/gevrey-chambertin-clos-st-jacques/"
                        >Gevrey-Chambertin, Clos St Jacques</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Meursault</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/the-wizards-of-meursault-1-coche-dury/"
                        >The Wizards of Meursault 1: Coche-Dury</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/the-wizards-of-meursault-2-domaine-arnaud-ente/"
                        >The wizards of Meursault 2: Domaine Arnaud Ente</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Montrachet</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/louis-jadot-chevalier-montrachet-les-demoiselles/"
                        >Louis Jadot: Chevalier-Montrachet Les Demoiselles</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Morey-St-Denis</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/dujac-double-double-bill-part-2-part-2-dujac-at-la-tour-dargent/"
                        >Domaine Dujac - a Double Double Bill (2)</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/dujac-double-double-bill-part1-clos-de-la-roche-and-clos-st-denis/"
                        >Domaine Dujac - a Double Double Bill (1)</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Volnay</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/mature-volnay/"
                        >Mature Volnay</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/volnay-santenots-du-milieu-domaine-des-comtes-lafon/"
                        >Domaine des Comtes Lafon: Volnay Santenots-du-Milieu</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Vosne-Romanée</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/an-echezeaux-vertical-67-pall-mall-december-2018/"
                        >An Echezeaux Vertical: 67 Pall Mall, December 2018</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/domaine-cathiard-retrospective/"
                        >Domaine Cathiard Retrospective</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/domaine-rene-engel-vertical/"
                        >Domaine René Engel Retrospective</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/la-grande-rue/"
                        >Domaine Lamarche: La Grande Rue</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/richebourg-domaine-jean-grivot-vertical/"
                        >Domaine Jean Grivot: Richebourg</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/richebourg-domaine-meo-camuzet/"
                        >Domaine Méo-Camuzet: Richebourg</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="trigger">Vougeot</a>
                    <ul style="display:none;">
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/clos-blanc-de-vougeot-vertical-2008-1999/"
                        >Domaine de la Vougeraie: Clos Blanc de Vougeot</a>
                      </li>
                      <li>
                        <a
                          href="https://www.insideburgundy.com/tasting_reports/clos-de-vougeot-grand-cru-domaine-leroy/"
                        >Domaine Leroy: Clos de Vougeot</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <div class="leftCol tastingIntro">
          <h2>JMIB tasting reports</h2>
          <p>
            The core activity of our Jasper Morris Inside Burgundy website is the provision of Tasting Reports. Each one of these provides an interesting narrative in its own right, while also populating the database which is growing all the time, and from which at any time you can check up on the current rating of any wine of interest. The Tasting Reports themselves come in various guises and this is fully explained below in “
            <a
              href="/introduction-to-tasting-reports/"
            >An introduction to Tasting Reports</a>”.
          </p>
          <p>&nbsp;</p>
          <h4>JMIB Tasting Notes</h4>
          <p>
            All wines are given both a point score and a star rating: A full explanation can be found by clicking on “
            <a
              href="/introduction-to-tasting-notes/"
            >An Introduction to Tasting Notes</a>” below.
          </p>
          <div class="gridBoxes two small">
            <ul>
              <li>
                <div class="content">
                  <div class="img">
                    <img
                      src="https://www.insideburgundy.com/wp-content/uploads/2018/09/banner-3-768x288.jpg"
                      alt="An Introduction to Tasting Notes"
                      class="cover-image"
                    >
                  </div>
                  <div class="discription">
                    <h6>An Introduction to Tasting Notes</h6>
                    <p>Find out more about the combination scales used alongside each other to help distinguish a truly successful wine.</p>
                  </div>
                  <a
                    href="index.html#/Qualification"
                    target
                    class="readmore"
                  >阅读更多</a>
                </div>
              </li>

              <li>
                <div class="content">
                  <div class="img">
                    <img
                      src="https://www.insideburgundy.com/wp-content/uploads/2018/09/2008-report.jpg"
                      alt="An Introduction to Tasting Reports"
                      class="cover-image"
                    >
                  </div>
                  <div class="discription">
                    <h6>An Introduction to Tasting Reports</h6>
                    <p>Find out more about how reports are separated into; En primeur barrel tastings, the Burgfest tastings, 10 year on &amp; 20 year on tastings, producer verticals and vineyard focus.</p>
                  </div>
                  <a
                    href="index.html#/Theactivity"
                    target
                    class="readmore"
                  >阅读更多</a>
                </div>
              </li>
            </ul>
            <!-- Top 3 blocks -->
          </div>

          <div class="recent_posts_grid">
            <div id="ajax_frame" class>
              <div id="ajax_content">
                <div class="gridBoxes three small">
                  <h2>最新报告</h2>
                  <ul>
                    <li>
                      <div class="content">
                        <div class="img">
                          <img
                            width="300"
                            height="229"
                            src="https://www.insideburgundy.com/wp-content/uploads/2019/05/Engel-300x229.jpg"
                            class="cover-image wp-post-image"
                            alt="Domaine René Engel Dinner"
                            srcset="https://www.insideburgundy.com/wp-content/uploads/2019/05/Engel-300x229.jpg 300w, https://www.insideburgundy.com/wp-content/uploads/2019/05/Engel.jpg 550w"
                            sizes="(max-width: 300px) 100vw, 300px"
                          >
                        </div>
                        <div class="discription">
                          <h6>Domaine René Engel Dinner</h6>A fascinating array of Engel wines was enjoyed over a fine dinner at Kowloon’s Michelin starred Epure restaurant, known for its fine wine list. The wines were served by vineyard in age order rather than by vintage. Possibly controversially Clos Vougeot came at the end, after Grands-Echezeaux but those who...
                        </div>
                        <a
                          href="index.html#"
                          target="_parent"
                          class="readmore"
                        >阅读更多</a>
                      </div>
                    </li>
                    <li>
                      <div class="content">
                        <div class="img">
                          <img
                            width="300"
                            height="229"
                            src="https://www.insideburgundy.com/wp-content/uploads/2019/04/Echezeaux-300x229.jpg"
                            class="cover-image wp-post-image"
                            alt="An Echezeaux Vertical: 67 Pall Mall, December 2018"
                            srcset="https://www.insideburgundy.com/wp-content/uploads/2019/04/Echezeaux-300x229.jpg 300w, https://www.insideburgundy.com/wp-content/uploads/2019/04/Echezeaux.jpg 550w"
                            sizes="(max-width: 300px) 100vw, 300px"
                          >
                        </div>
                        <div class="discription">
                          <h6>An Echezeaux Vertical: 67 Pall Mall, December 2018</h6>Echezeaux is a name which resonates, but also confounds. There’s a lot of it – the second largest grand cru in the Côte de Nuits, after Clos de Vougeot, though there is even confusion as to the exact size of Echezeaux: the component parts don’t add up to the figure...
                        </div>
                        <a
                          href="index.html#"
                          target="_parent"
                          class="readmore"
                        >阅读更多</a>
                      </div>
                    </li>
                    <li>
                      <div class="content">
                        <div class="img">
                          <img
                            width="300"
                            height="229"
                            src="https://www.insideburgundy.com/wp-content/uploads/2019/04/New-Zealand-Central-Otago-Pinot-Noir-report-Summer-at-Domaine-Thomson-300x229.jpg"
                            class="cover-image wp-post-image"
                            alt="Central Otago Pinot Noir Celebration"
                            srcset="https://www.insideburgundy.com/wp-content/uploads/2019/04/New-Zealand-Central-Otago-Pinot-Noir-report-Summer-at-Domaine-Thomson-300x229.jpg 300w, https://www.insideburgundy.com/wp-content/uploads/2019/04/New-Zealand-Central-Otago-Pinot-Noir-report-Summer-at-Domaine-Thomson.jpg 550w"
                            sizes="(max-width: 300px) 100vw, 300px"
                          >
                        </div>
                        <div class="discription">
                          <h6>Central Otago Pinot Noir Celebration</h6>Some 20 years after my first visit to Central Otago I found myself back in a very different landscape. The region has gone from some experimental plantings in the Cromwell basin to supplement the Gibbston Valley, to a flourishing region with over 1900 ha in production (of which 80% is...
                        </div>
                        <a
                          href="index.html#"
                          target="_parent"
                          class="readmore"
                        >阅读更多</a>
                      </div>
                    </li>
                    <li>
                      <div class="content">
                        <div class="img">
                          <img
                            width="300"
                            height="229"
                            src="https://www.insideburgundy.com/wp-content/uploads/2019/04/London-2017s-January-tasting-Corton-300x229.jpg"
                            class="cover-image wp-post-image"
                            alt="2017s in London"
                            srcset="https://www.insideburgundy.com/wp-content/uploads/2019/04/London-2017s-January-tasting-Corton-300x229.jpg 300w, https://www.insideburgundy.com/wp-content/uploads/2019/04/London-2017s-January-tasting-Corton.jpg 550w"
                            sizes="(max-width: 300px) 100vw, 300px"
                          >
                        </div>
                        <div class="discription">
                          <h6>2017s in London</h6>The first full week in January keeps the Eurostar busy as Burgundian vignerons flock to London to show off their new vintage. I took advantage of the 2019 version, with the 2017 vintage on display, to taste a large range of wines from producers whom I had not been able...
                        </div>
                        <a
                          href="index.html#"
                          target="_parent"
                          class="readmore"
                        >阅读更多</a>
                      </div>
                    </li>
                    <li>
                      <div class="content">
                        <div class="img">
                          <img
                            width="300"
                            height="229"
                            src="https://www.insideburgundy.com/wp-content/uploads/2019/03/2002-Tasting-HK-300x229.jpg"
                            class="cover-image wp-post-image"
                            alt="2002 Revisited"
                            srcset="https://www.insideburgundy.com/wp-content/uploads/2019/03/2002-Tasting-HK-300x229.jpg 300w, https://www.insideburgundy.com/wp-content/uploads/2019/03/2002-Tasting-HK.jpg 550w"
                            sizes="(max-width: 300px) 100vw, 300px"
                          >
                        </div>
                        <div class="discription">
                          <h6>2002 Revisited</h6>A cheerful array of relatively top end 2002 Burgundies were enjoyed over dinner at the American Club in Hong Kong in January 2019. The meal began with three versions of Krug 2002, the NV with 2002 as the base, the vintage Krug 2002 and finally the delicious Clos du Mesnil....
                        </div>
                        <a
                          href="index.html#"
                          target="_parent"
                          class="readmore"
                        >阅读更多</a>
                      </div>
                    </li>
                    <li>
                      <div class="content">
                        <div class="img">
                          <img
                            width="300"
                            height="229"
                            src="https://www.insideburgundy.com/wp-content/uploads/2019/04/Marechale-1-300x229.jpg"
                            class="cover-image wp-post-image"
                            alt="Domaine J-F Mugnier vertical: Clos de la Maréchale"
                            srcset="https://www.insideburgundy.com/wp-content/uploads/2019/04/Marechale-1-300x229.jpg 300w, https://www.insideburgundy.com/wp-content/uploads/2019/04/Marechale-1.jpg 550w"
                            sizes="(max-width: 300px) 100vw, 300px"
                          >
                        </div>
                        <div class="discription">
                          <h6>Domaine J-F Mugnier vertical: Clos de la Maréchale</h6>Heading north up the D974, the very first premier cru of the Côte de Nuits is Mugnier’s Clos de la Maréchale. It has been in the family since 1902, though for fifty years up to 2004 it was on loan to Faiveley. Frédéric was like a cat with two tails...
                        </div>
                        <a
                          href="index.html#"
                          target="_parent"
                          class="readmore"
                        >阅读更多</a>
                      </div>
                    </li>
                    <li>
                      <div class="content">
                        <div class="img">
                          <img
                            width="300"
                            height="229"
                            src="https://www.insideburgundy.com/wp-content/uploads/2019/04/Pommard-300x229.jpg"
                            class="cover-image wp-post-image"
                            alt="Domaine du Comte Armand: Clos des Epeneaux, Pommard"
                            srcset="https://www.insideburgundy.com/wp-content/uploads/2019/04/Pommard-300x229.jpg 300w, https://www.insideburgundy.com/wp-content/uploads/2019/04/Pommard.jpg 550w"
                            sizes="(max-width: 300px) 100vw, 300px"
                          >
                        </div>
                        <div class="discription">
                          <h6>Domaine du Comte Armand: Clos des Epeneaux, Pommard</h6>One of the most memorable tastings of my life was a vertical organised by Benjamin Leroux when he was managing the Domaine du Comte Armand, to celebrate the putative bi-centenary of the original walling of the Clos shortly after the Comte Armand’s family had bought the vineyard in the early...
                        </div>
                        <a
                          href="index.html#"
                          target="_parent"
                          class="readmore"
                        >阅读更多</a>
                      </div>
                    </li>
                    <li>
                      <div class="content">
                        <div class="img">
                          <img
                            width="300"
                            height="229"
                            src="https://www.insideburgundy.com/wp-content/uploads/2019/03/clos-de-beze-300x229.jpg"
                            class="cover-image wp-post-image"
                            alt="Domaine Bruno Clair: Chambertin Clos de Bèze"
                            srcset="https://www.insideburgundy.com/wp-content/uploads/2019/03/clos-de-beze-300x229.jpg 300w, https://www.insideburgundy.com/wp-content/uploads/2019/03/clos-de-beze.jpg 550w"
                            sizes="(max-width: 300px) 100vw, 300px"
                          >
                        </div>
                        <div class="discription">
                          <h6>Domaine Bruno Clair: Chambertin Clos de Bèze</h6>This fascinating tasting of Domaine Bruno Clair’s Chambertin Clos de Bèze, covering vintages from 2011 back to 1989, took place in Burgundy on 18th November 2014, thanks to the generosity of collector Richard Orders from whose cellar the wines were sourced. In most instances the wines had been purchased En...
                        </div>
                        <a
                          href="index.html#"
                          target="_parent"
                          class="readmore"
                        >阅读更多</a>
                      </div>
                    </li>
                    <li>
                      <div class="content">
                        <div class="img">
                          <img
                            width="300"
                            height="233"
                            src="https://www.insideburgundy.com/wp-content/uploads/2019/03/Domaine-Bachelet-300x233.jpg"
                            class="cover-image wp-post-image"
                            alt="Domaine Denis Bachelet: Charmes Chambertin Vieilles Vignes"
                            srcset="https://www.insideburgundy.com/wp-content/uploads/2019/03/Domaine-Bachelet-300x233.jpg 300w, https://www.insideburgundy.com/wp-content/uploads/2019/03/Domaine-Bachelet.jpg 540w"
                            sizes="(max-width: 300px) 100vw, 300px"
                          >
                        </div>
                        <div class="discription">
                          <h6>Domaine Denis Bachelet: Charmes Chambertin Vieilles Vignes</h6>The Bachelet holding of Charmes-Chambertin is within Charmes, but close to the border with Mazoyères. The vines are mostly ancient, planted at the tail end of the 19th and the early 20th centuries, apart from 6 rows replanted by Denis’s grandparents in 1960s. Tiny grapes, always the first to ripen...
                        </div>
                        <a
                          href="index.html#"
                          target="_parent"
                          class="readmore"
                        >阅读更多</a>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="pagination">
                  <span aria-current="page" class="page-numbers current">1</span>
                  <a
                    class="page-numbers"
                    href="https://www.insideburgundy.com/wp-content/themes/burgundy/reports_list.php/page/2/"
                  >2</a>
                  <a
                    class="page-numbers"
                    href="https://www.insideburgundy.com/wp-content/themes/burgundy/reports_list.php/page/3/"
                  >3</a>
                  <a
                    class="page-numbers"
                    href="https://www.insideburgundy.com/wp-content/themes/burgundy/reports_list.php/page/4/"
                  >4</a>
                  <a
                    class="page-numbers"
                    href="https://www.insideburgundy.com/wp-content/themes/burgundy/reports_list.php/page/5/"
                  >5</a>
                  <a
                    class="page-numbers"
                    href="https://www.insideburgundy.com/wp-content/themes/burgundy/reports_list.php/page/6/"
                  >6</a>
                  <a
                    class="next page-numbers"
                    href="https://www.insideburgundy.com/wp-content/themes/burgundy/reports_list.php/page/2/"
                  >
                    Next Page
                    <i></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>
import searchBox from '../template/search'

export default {
  components:{
    searchBox
  },
  methods: {
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Consultation.vue